import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import React from 'react';
import { themeConfig } from 'src/theme';
import { Iconify } from '../iconify';

const Accordion = ({ children }: { children: React.ReactNode }) => (
  <div className="w-full flex flex-col gap-[38px]">{children}</div>
);

const Header = ({ children }: { children: React.ReactNode }) => (
  <DisclosureButton className="group h-[76px] px-[14px] md:px-[28px] py-[0px] md:py-[20px] bg-[#fefe01]/5 justify-between items-center inline-flex">
    {children}
    <div data-svg-wrapper className="relative">
      <Iconify
        icon="line-md:chevron-down"
        sx={{
          color: themeConfig.palette.primary.main,
        }}
        className="group-data-[open]:rotate-180 text-amber-400"
      />
    </div>
  </DisclosureButton>
);

const Body = ({ children }: { children: React.ReactNode }) => (
  <DisclosurePanel
    transition
    className="text-[#1c252e] text-base font-normal font-['Public Sans'] leading-normal px-[10px] py-[16px] md:px-[20px] md:py-[28px] border-t-1 border-[#10ba17]"
  >
    {children}
  </DisclosurePanel>
);

const Item = ({ children, defaultOpen }: { children: React.ReactNode; defaultOpen?: boolean }) => (
  <Disclosure defaultOpen={defaultOpen}>
    <div className="flex flex-col rounded-[10px] border border-[#10ba17]">{children}</div>
  </Disclosure>
);

Accordion.Header = Header;
Accordion.Body = Body;
Accordion.Item = Item;

export default Accordion;
